const GA_ID = process.env.REACT_APP_GA4_ID;
const CONSENT_KEY = "om_cookie_consent"; // "accepted" | "declined"

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* ignore */
  }
}

let gaLoaded = false;

// Loads GA4 (gtag.js) only when called. Never runs before explicit consent.
export function loadGA() {
  if (gaLoaded || !GA_ID) return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true });
}

export function hasGA() {
  return !!GA_ID;
}
